import antdHi from "antd/lib/locale-provider/hi_IN";
import appLocaleData from "react-intl/locale-data/hi";
import enMessages from "../locales/en_US.json";
import hiMessages from "../locales/hi_IN.json";

const HiLang = {
  messages: {
    ...enMessages,
    ...hiMessages
  },
  antd: antdHi,
  locale: 'hi',
  data: appLocaleData
};
export default HiLang;
